export const MAX_OTP_ATTEMPTS = 3;

export const OTP_RESEND_COOLDOWN_SECONDS = 60;
